import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar } from "./Avatar";
import { StyleTag } from "./ui-bits";
import { timeAgo } from "../lib/constants";
import { Music4, ChevronRight } from "lucide-react";

export function SearchCard({ search, onClick, ctaLabel = "Voir la recherche", matchedStyles, testIdPrefix = "search-card" }) {
  const nav = useNavigate();
  const handle = onClick || (() => nav(`/app/search/${search.id}`));
  return (
    <div
      onClick={handle}
      data-testid={`${testIdPrefix}-${search.id}`}
      className="group bg-[#0B0716] border border-zinc-800/80 rounded-2xl p-5 cursor-pointer hover:border-violet-500 hover:bg-[#17103A] transition-colors duration-300 animate-fade-up neon-card scanlines relative overflow-hidden"
    >
      <div className="flex items-center gap-3 mb-3">
        <Avatar user={search.artist} size={38} />
        <div className="min-w-0">
          <p className="font-semibold text-sm truncate">🎤 @{search.artist?.pseudo}</p>
          <p className="text-xs text-zinc-500">{timeAgo(search.created_at)}</p>
        </div>
        {matchedStyles?.length > 0 ? (
          <span className="ml-auto text-[10px] font-mono uppercase px-2 py-0.5 rounded-full bg-violet-600/20 text-violet-300 border border-violet-600/30">
            ✨ {matchedStyles.slice(0, 2).join(" · ")}
          </span>
        ) : search.status === "completed" ? (
          <span className="ml-auto text-[10px] font-mono uppercase px-2 py-0.5 rounded-full bg-zinc-700/60 text-zinc-300">Terminée</span>
        ) : null}
      </div>
      <h3 className="font-display font-semibold text-base leading-snug mb-3 line-clamp-2">{search.title}</h3>
      <div className="flex flex-wrap gap-1.5 mb-3">
        {(search.styles || []).slice(0, 3).map((s) => <StyleTag key={s}>{s}</StyleTag>)}
      </div>
      <div className="flex items-center gap-4 text-xs font-mono text-zinc-400 mb-4">
        {(search.bpm_min || search.bpm_max) && (
          <span>BPM {search.bpm_min || "?"}{search.bpm_max ? `–${search.bpm_max}` : ""}</span>
        )}
        {search.budget && <span className="text-emerald-400">{search.budget}</span>}
      </div>
      <div className="flex items-center justify-between pt-3 border-t border-zinc-800">
        <span className="flex items-center gap-1.5 text-xs text-zinc-400">
          <Music4 size={14} className="text-violet-400" />
          {search.submission_count || 0} proposition{(search.submission_count || 0) > 1 ? "s" : ""}
          {typeof search.my_submission_count === "number" && (
            <span className="ml-1 text-violet-300">· {search.my_submission_count}/3 envoyées</span>
          )}
        </span>
        <span className="flex items-center gap-1 text-sm font-medium text-violet-400 group-hover:gap-2 transition-all">
          {ctaLabel} <ChevronRight size={16} />
        </span>
      </div>
    </div>
  );
}
